import gql from 'graphql-tag';

export const byDokkioLabelIDCountFragment = gql`
  fragment byDokkioLabelIDCountFragment on ByDokkioLabelIDCount {
    dokkioLabelID
    count
  }
`;
export default byDokkioLabelIDCountFragment;
